<template>
    <div>
        <input type="checkbox" :checked="value" @change="update($event)" :name="field.name" />
        <label :for="field.name">{{ field.desc ? field.desc : 'I agree' }}</label>
    </div>
</template>

<script>
    export default {
        name: 'v-check-field',
        props:['value', 'field'],
        methods:{
            update(ev){
                this.$emit('input', ev.target.checked)
            }
        },
    }
</script>

<style scoped lang="scss">
</style>
